// Form events — tracks form interactions (Form Start, Form Error, Form Submit)

import { pushAdobeEvent } from './core';
import { getCurrentPagePayload } from './pageLoad';

export type FormStartParams = {
  formName: string | number;
};

export type FormErrorParams = {
  errorText: string;
};

export type FormSubmitParams = {
  formName: string | number;
};

// Pushes a Form Start event to the Adobe Client Data Layer — fired the first time a form is focused
export const trackAdobeFormStart = (params: FormStartParams): void => {
  const eventName = 'Form Start';
  const page = getCurrentPagePayload();
  pushAdobeEvent({
    event: eventName,
    eventName,
    eventDesc: `${eventName} - ${params.formName}`,
    ...(page && { page }),
    form: {
      formName: params.formName,
    },
  });
};

// Pushes a Form Error event to the Adobe Client Data Layer — fired when validation or submission fails
export const trackAdobeFormError = (params: FormErrorParams): void => {
  const eventName = 'Form Error';
  const page = getCurrentPagePayload();
  pushAdobeEvent({
    event: eventName,
    eventName,
    eventDesc: `${eventName} - ${params.errorText}`,
    ...(page && { page }),
    form: {
      errorText: params.errorText,
    },
  });
};

// Pushes a Form Submit event to the Adobe Client Data Layer — fired on a successful submission
export const trackAdobeFormSubmit = (params: FormSubmitParams): void => {
  const eventName = 'Form Submit';
  const page = getCurrentPagePayload();
  pushAdobeEvent({
    event: eventName,
    eventName,
    eventDesc: `${eventName} - ${params.formName}`,
    ...(page && { page }),
    form: {
      formName: params.formName,
    },
  });
};
